import { BrandOverlayEntity } from "@common/domain";
import { createAction, props } from "@ngrx/store";

export const brandOverlayCreateSuccess = createAction(
  "[Brand Overlay] Create Success",
  props<{ brandOverlay: BrandOverlayEntity }>()
);

export const brandOverlayDeleteSuccess = createAction(
  "[Brand Overlay] Delete Success",
  props<{ brandOverlay: BrandOverlayEntity }>()
);

export const brandOverlayUseSuccess = createAction(
  "[Brand Overlay] Use Success",
  props<{ brandOverlay: BrandOverlayEntity }>()
);

export const brandOverlayUnUseSuccess = createAction(
  "[Brand Overlay] Un Use Success",
  props<{ brandOverlay: BrandOverlayEntity }>()
);
